export default {
  //get all SUPERADMIN_PDFs
  GET_SUPERADMIN_PDFS_REQUEST: "GET_SUPERADMIN_PDFS_REQUEST",
  GET_SUPERADMIN_PDFS_SUCCESS: "GET_SUPERADMIN_PDFS_SUCCESS",
  GET_SUPERADMIN_PDFS_FAIL: "GET_SUPERADMIN_PDFS_FAIL",

  //edit SUPERADMIN_PDFs
  EDIT_SUPERADMIN_PDF_REQUEST: "EDIT_SUPERADMIN_PDF_REQUEST",
  EDIT_SUPERADMIN_PDF_SUCCESS: "EDIT_SUPERADMIN_PDF_SUCCESS",
  EDIT_SUPERADMIN_PDF_FAIL: "EDIT_SUPERADMIN_PDF_FAIL",

  //create SUPERADMIN_PDF
  CREATE_SUPERADMIN_PDF_REQUEST: "CREATE_SUPERADMIN_PDF_REQUEST",
  CREATE_SUPERADMIN_PDF_SUCCESS: "CREATE_SUPERADMIN_PDF_SUCCESS",
  CREATE_SUPERADMIN_PDF_FAIL: "CREATE_SUPERADMIN_PDF_FAIL",

  DELETE_SUPERADMIN_PDF_REQUEST: "DELETE_SUPERADMIN_PDF_REQUEST",
  DELETE_SUPERADMIN_PDF_SUCCESS: "DELETE_SUPERADMIN_PDF_SUCCESS",
  DELETE_SUPERADMIN_PDF_FAIL: "DELETE_SUPERADMIN_PDF_FAIL",

  GET_SUPERADMIN_PDF_REQUEST: "GET_SUPERADMIN_PDF_REQUEST",
  GET_SUPERADMIN_PDF_SUCCESS: "GET_SUPERADMIN_PDF_SUCCESS",
  GET_SUPERADMIN_PDF_FAIL: "GET_SUPERADMIN_PDF_FAIL",

  SUPERADMIN_GET_COURSE_PDF_REQUEST: "SUPERADMIN_GET_COURSE_PDF_REQUEST",
  SUPERADMIN_GET_COURSE_PDF_SUCCESS: "SUPERADMIN_GET_COURSE_PDF_SUCCESS",
  SUPERADMIN_GET_COURSE_PDF_FAIL: "SUPERADMIN_GET_COURSE_PDF_FAIL",

  //loading
  ADD_SUPERADMIN_PDFS_LOADING: "ADD_SUPERADMIN_PDFS_LOADING",
};
